export default __webpack_public_path__ + "static/media/user3.2139edce.svg";